import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  {
    id: "id",
    label: "S.NO",
    minWidth: 100,
    align: "center",
  },
  {
    id: "convenience_fee",
    label: "CONVENIENCE FEE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "max_convenience_fee",
    label: "MAX CONVENIENCE FEE",
    minWidth: 230,
    align: "center",
  },
  {
    id: "far_delivery_gomak_fee",
    label: "FAR DELIVERY FEE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "snap_ryder_assignment_delay",
    label: "SNAP RYDER ASSIGNMENT DELAY IN SECONDS",
    minWidth: 280,
    align: "center",
  },
  {
    id: "in_process_expiry_time",
    label: "In Process Expiry Time",
    minWidth: 210,
    align: "center",
  },
  {
    id: "new_order_expiry_time",
    label: "New Order Expiry Time",
    minWidth: 210,
    align: "center",
  },
  {
    id: "admin_mobile_no",
    label: "Admin Mobile No",
    minWidth: 210,
    align: "center",
  },
  {
    id: "admin_email",
    label: "Admin Email",
    minWidth: 210,
    align: "center",
  },
  {
    id: "bonvoice_whatsapp_no",
    label: "Bonvoice Whatsapp No",
    minWidth: 210,
    align: "center",
  },
  {
    id: "agent_withdraw_limit",
    label: "Agent withdraw limit",
    minWidth: 210,
    align: "center",
  },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  id,
  convenience_fee,
  max_convenience_fee,
  far_delivery_gomak_fee,
  snap_ryder_assignment_delay,
  in_process_expiry_time,
  new_order_expiry_time,
  admin_mobile_no,
  admin_email,
  bonvoice_whatsapp_no,
  agent_withdraw_limit
) {
  return {
    id,
    convenience_fee,
    max_convenience_fee,
    far_delivery_gomak_fee,
    snap_ryder_assignment_delay,
    in_process_expiry_time,
    new_order_expiry_time,
    admin_mobile_no,
    admin_email,
    bonvoice_whatsapp_no,
    agent_withdraw_limit,
  };
}

export const GlobalSetting = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [globalSettingList, setGlobalSettingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchGlobalSetting = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/internal-settings/1/");
      console.log("Global Setting response:", res.data);

      // If API returns single object → wrap it in array
      if (res.data) {
        setGlobalSettingList([res.data]);
      } else {
        setError("Failed to fetch Global Setting data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Global Setting data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlobalSetting();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">Global Setting</div>
          <div>
            {/* <select className="listAdmin-showRecords">
                  <option>Show No of Records</option>
                  <option>10</option>
                  <option>25</option>
                  <option>50</option>
                  <option>100</option>
                </select> */}
          </div>
          <div className="search-container">
            {/* <div className="nav-search ">
                  <span className="search-icons">
                    <GoSearch />
                  </span>
                  <input type="text" placeholder="Search"></input>
                </div> */}
          </div>
          {/* <div className="btnAdd">
            <button onClick={() => navigate("/ryder-zone-add")}>
              + Add Ryder Zone
            </button>
          </div> */}
        </div>
        <section>
          {loading ? (
            <div className="loader-wrap">
              <CircularProgress />
            </div>
          ) : globalSettingList.length > 0 ? (
            globalSettingList.map((row, index) => (
              <div className="setting-card" key={index}>
                <button
                  className="edit-floating-btn"
                  onClick={() => navigate(`/global-setting-edit/${row.id}`)}
                >
                  <EditIcon />
                </button>

                <div className="setting-grid">
                  {/* <div className="setting-item">
                    <span>CONVENIENCE FEE:</span>
                    <p>₹{Number(row.convenience_fee || 0)}</p>
                  </div> */}

                  {/* <div className="setting-item">
                    <span>MAX CONVENIENCE FEE:</span>
                    <p>₹{Number(row.max_convenience_fee || 0)}</p>
                  </div> */}

                  <div className="setting-item">
                    <span>FAR DELIVERY FEE:</span>
                    <p>{Number(row.far_delivery_gomak_fee || 0)}%</p>
                  </div>

                  <div className="setting-item">
                    <span>SNAP RYDER ASSIGNMENT DELAY:</span>
                    <p>{Number(row.snap_ryder_assignment_delay)} seconds</p>
                  </div>

                  <div className="setting-item">
                    <span>IN PROCESS EXPIRY TIME:</span>
                    <p>{Number(row.in_process_expiry_time)} Hours</p>
                  </div>

                  <div className="setting-item">
                    <span>NEW ORDER EXPIRY TIME:</span>
                    <p>{Number(row.new_order_expiry_time)} Hours</p>
                  </div>

                  <div className="setting-item">
                    <span>ADMIN MOBILE NO:</span>
                    <p>{row.admin_mobile_no || "--"}</p>
                  </div>

                  <div className="setting-item">
                    <span>ADMIN EMAIL:</span>
                    <p>{row.admin_email || "--"}</p>
                  </div>

                  <div className="setting-item">
                    <span>BONVOICE WHATSAPP NO:</span>
                    <p>{row.bonvoice_whatsapp_no || "--"}</p>
                  </div>

                  <div className="setting-item">
                    <span>AGENT WITHDRAW LIMIT:</span>
                    <p>₹{Number(row.agent_withdraw_limit || 0)}</p>
                  </div>

                  <div className="setting-item">
                    <span>BONVOICE PHONE NUMBER ID:</span>
                    <p>{Number(row.bonvoice_phone_number_id || 0)}</p>
                  </div>

                  <div className="setting-item">
                    <span>WORKING HOURS:</span>
                    <p>{row.working_hour || "--"}</p>
                  </div>

                  <div className="setting-item">
                    <span>WORKING DAYS:</span>
                    <p>{row.working_days || "--"}</p>
                  </div>
                   <div className="setting-item">
                    <span>PLATFORM FEE:</span>
                    <p>₹{row.platform_fee || "--"}</p>
                  </div>
                  <div className="setting-item">
                    <span>ADHOC ORDER COMMISSION:</span>
                    <p>{Number(row.adhoc_order_commision || 0)}%</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="no-data">No Data Available</p>
          )}
        </section>
      </div>
    </>
  );
};
